import request from "@/utils/request";

export default function agentGetDeviceVersionList() {
    return request({
        url: `/device/deviceType/getAllDeviceType`,
    })
}